import { fetchActivityTypes } from 'services/activityTypes/actions'
import {
  FETCH_USER_STATS,
  FETCH_LIFETIME_STATS,
} from './constants'

export function getUserStats (userId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: FETCH_USER_STATS,
      payload: mapmy.getUserStatsSummary(userId),
    })
  }
}

export function getLifetimeStats (userId) {
  return (dispatch) => {
    return dispatch({
      type: FETCH_LIFETIME_STATS,
      payload: Promise.all([
        dispatch(getUserStats(userId)),
        dispatch(fetchActivityTypes()),
      ]),
    })
  }
}
